export interface IUOTState {
    getUOTDetails : any;
    getUOTSuccessMessage : any;
    getUOTErrorMessage : any;
    getAllProducttypesSuccess: any;
    getAllProducttypesError: any;
    getAddProductTypeSuccess: any;
    getAddProductTypeError: any;
    getEditProductTypeSuccess :  any;
    getEditProductTypeError: any;

}

export const initialUOTState : IUOTState =  {
    getUOTDetails : null,
    getUOTSuccessMessage : null,
    getUOTErrorMessage : null,
    getAllProducttypesSuccess: null,
    getAllProducttypesError: null,
    getAddProductTypeSuccess: null,
    getAddProductTypeError: null,
    getEditProductTypeSuccess : null,
    getEditProductTypeError: null,
}